module.exports = __webpack_public_path__ + "static/img/img-4.2d3b49f4.png";